import Amount from "components/departmental-line-items/controls/amount"
import AmtPerArea from "components/departmental-line-items/controls/amt-per-area"
import Cap from "components/departmental-line-items/controls/cap"
import DeleteConfirmation from "components/departmental-line-items/controls/delete-confirmation"
import Detailed from "components/departmental-line-items/controls/detailed"
import DetailedPerArea from "components/departmental-line-items/controls/detailed-per-area"
import DetailedPercentLine from "components/departmental-line-items/controls/detailed-percent-line"
import Floor from "components/departmental-line-items/controls/floor"
import InputTypeAtRest from "components/departmental-line-items/controls/input-type-at-rest"
import PercentEGR from "components/departmental-line-items/controls/percent-egr"
import PercentLine from "components/departmental-line-items/controls/percent-line"
import PercentTenantRevenue from "components/departmental-line-items/controls/percent-tenant-revenue"
import Prop13Tax from "components/departmental-line-items/controls/prop13tax"

export default {
  Amount,
  AmtPerArea,
  Cap,
  DeleteConfirmation,
  Detailed,
  DetailedPerArea,
  DetailedPercentLine,
  Floor,
  InputTypeAtRest,
  PercentEGR,
  PercentLine,
  PercentTenantRevenue,
  Prop13Tax
}
